(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('ManageUsersController', ManageUsersController);

    ManageUsersController.$inject = ['$controller','$sce','$uibModalInstance', 'entity', 'parameters', 'SoopkitchenUtils', 'Planning', 'AuthServerProvider', 'PlanTypes'];

    function ManageUsersController($controller, $sce, $uibModalInstance, entity, parameters, SoopkitchenUtils, Planning, AuthServerProvider, PlanTypes) {

        var vm = this;

        var title = 'Set Users with Editing Rights for <span class="label label-info">'+entity.label+'</span>';
        angular.extend(this, $controller('SoopkitchenDialogController',
            {"title": title, $sce: $sce, $uibModalInstance:$uibModalInstance}));

        /**** Properties ****/


        vm.plan = entity;
        vm.planType = parameters.planType;
        vm.allUsers = [];

        vm.selectedUsers = vm.plan.planUserInfo.usersWithRights.sort();

        vm.isMaster = vm.planType === PlanTypes['master'];
        //Overriding Properties from SoopkitchenDialogController:
        vm.saveText = "Set";

        vm.toggleSelection = function toggleSelection(user) {
            var idx = vm.selectedUsers.indexOf(user);

            // Is currently selected
            if (idx > -1) {
                vm.selectedUsers.splice(idx, 1);
            }

            // Is newly selected
            else {
                vm.selectedUsers.push(user);
            }
        };

        vm.checkAllUsers = function checkAllUsers(planUsers, checkAllValue) {
            vm.selectedUsers = [];
            if (checkAllValue) {
                for (var i = 0; i < planUsers.length; i++) {
                    vm.selectedUsers.push(planUsers[i]);
                }
            }
        };

        /**** Methods ****/
        //Override Methods from SoopkitchenDialogController
        vm.save = setUsers;

        var authoritiesToAdd = 'ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER';
        if (vm.isMaster) {
            authoritiesToAdd = 'ROLE_INSTRUMENT_COORDINATOR';
        }

        function successGetUsers(response) {
            var i;
            for (i = 0; i < response.data.length; i++) {
                vm.allUsers.push(response.data[i].login);
            }
            vm.allUsers.sort();
        }
        function failure(response) {
            SoopkitchenUtils.prettyError(response);
        }

        AuthServerProvider.getUsersByAuthority(successGetUsers,failure, authoritiesToAdd);


        function setUsers() {
            var usernames = '';
            if (vm.selectedUsers.length > 0) {
                usernames = vm.selectedUsers;
            }
            Planning.setUsers(
                {
                    planType: vm.planType,
                    usernames: usernames,
                    planLabel: vm.plan.label,
                },
                function successCallback() {
                    location.reload();
                    $uibModalInstance.dismiss('cancel');
                }, failure
            );
        }
    }
})();
